import { Injectable } from '@angular/core';
import { UidGenerator } from '../../utils/uidGenerator';
import { BullhornNamespace } from '../service.provider.service';
import { IFunction } from './ifunction';
import { IFunctionProvider } from './ifunctionprovider';

type QueryForFileDataConfig = {
  name: string;
  entityType: string;
  fileType: string;
  out: string;
};

@Injectable({ providedIn: 'root' })
export class BullhornFunctionProviderService implements IFunctionProvider {
  // private nameToFunctionMap: {[key:string]: (functionConfig: any) => IFunction} = {
  //   'queryForFileData': this.buildQueryForFileData
  // };

  constructor() {}

  async build(functionConfig: any): Promise<IFunction> {
    if (functionConfig.name === 'queryForFileData') {
      return this.buildQueryForFileData(functionConfig);
    }

    throw new Error(`Unknown function ${functionConfig.name}.`);
  }

  private async buildQueryForFileData(functionConfig: QueryForFileDataConfig): Promise<IFunction> {
    const entityIdPath = `${functionConfig.entityType}.id`;

    // server will always pull id for entities anyway
    // if we need more fields do: await this.serverModelService.insertPath(BullhornNamespace.name, <fieldPath>);

    return {
      id: UidGenerator.generateUUID(),
      namespace: BullhornNamespace.name,
      type: 'function',
      config: {
        name: 'queryForFileData',
        args: {
          entityType: functionConfig.entityType,
          entityId: `[(\${${BullhornNamespace.name}.${entityIdPath}})]`,
          fileType: functionConfig.fileType,
        },
        out: functionConfig.out,
      },
      fullyQualifiedName: `${BullhornNamespace.name}.queryForFileData`,
    };
  }
}
